import TrainerAttendanceLists from '../../features/trainer/TrainerAttendanceLists'


const TrainerAttendanceListPage = () => {
  return <TrainerAttendanceLists/>
}

export default TrainerAttendanceListPage